module.exports = __webpack_public_path__ + "img/tabs-guide.132e0e19.png";